import { DetailedHTMLProps, ImgHTMLAttributes, useRef } from 'react'

import Cover1 from './cover1.svg'
import Cover2 from './cover2.svg'
import Cover3 from './cover3.svg'
import Cover4 from './cover4.svg'
import Cover5 from './cover5.svg'
import Cover6 from './cover6.svg'
import Cover7 from './cover7.svg'
import Cover8 from './cover8.svg'

const covers = [Cover1, Cover2, Cover3, Cover4, Cover5, Cover6, Cover7, Cover8]

export function ArticleCover({
  src,
  ...props
}: DetailedHTMLProps<ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>) {
  const number = stringToNumber(props?.alt || props?.title || '')
  const randomImage = useRef(covers[number] ?? covers[0])
  return <img {...props} src={src || randomImage.current.src} />
}

function stringToNumber(inputString) {
  const hashValue = inputString.split('').reduce(function (a, b) {
    a = (a << 5) - a + b.charCodeAt(0)
    return a & a
  }, 0)
  return Math.abs(hashValue % (covers.length + 1))
}
